<script setup lang="ts">
import type { SubmitEventPromise } from 'vuetify';
// import type * as openapi from '@/helpers/api/types/openapiOverrides';

import { reactive, ref, toRaw } from 'vue';

import KNumberField from '@/components/fields/KNumberField.vue';
import useForm from '@/composables/useForm';
import { requiredValidationRule } from '@/helpers/validationRules';

export interface InitialData {
  quantity?: number;
}

export interface ValidData {
  quantity: number;
}

export interface Props {
  loading?: boolean;
  initialData?: InitialData;
  maxQuantity?: number;
}
const props = withDefaults(defineProps<Props>(), {
  loading: false,
  initialData: () => ({}),
  maxQuantity: undefined,
});
const emit = defineEmits<{
  submit: [event: SubmitEventPromise | null | undefined, formData: ValidData];
}>();

const formData = reactive<InitialData>({});
const isValid = ref(true);

const { form, handleSubmit } = useForm(props, formData, function (event) {
  emit('submit', event, toRaw(formData) as ValidData);
});
</script>

<template>
  <v-form
    ref="form"
    v-model="isValid"
    validate-on="lazy"
    :class="$style.newAirRoadUnpackDialogForm"
    data-testid="newAirRoadUnpackDialogForm"
    @submit.prevent="handleSubmit"
  >
    <KNumberField
      v-model="formData.quantity"
      :min="1"
      :max="props.maxQuantity"
      clearable
      label="Quantity"
      :disabled="props.loading"
      :rules="[requiredValidationRule]"
      :class="$style.field"
      autofocus
    />
    <input type="submit" class="hidden" :disabled="props.loading" />
  </v-form>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.newAirRoadUnpackDialogForm {
}
  .field {
  }
</style>
